import { FixedSizeList } from "react-window";

export default function ListProducts({
  listSize,
  gridSize,
  productsDataList,
  headerData,
}) {
  return (
    <FixedSizeList
      height={listSize.height || 400}
      width={listSize.width || gridSize.width || 600}
      itemCount={productsDataList.length}
      itemSize={56}
      itemKey={(index) => productsDataList[index]?.id || index}
      overscanCount={6}
    >
      {({ index, style }) => {
        const row = productsDataList[index];
        if (!row) return null;
        const gridTemplateColumns = "10% 60% 30%";
        return (
          <div
            style={{
              ...style,
              display: "grid",
              gridTemplateColumns,
              alignItems: "left",
              width: "100%",
              boxShadow: "0px -2px 0px 0px #d7e5f8 inset",
            }}
            className="common-table-wrapper common-table-row"
            role="row"
          >
            <div
              className={headerData[0].itemClassName}
              data-testid={headerData[0].columnKey}
            >
              {headerData[0].render(row, index)}
            </div>
            <div
              className={headerData[1].itemClassName}
              data-testid={headerData[1].columnKey}
            >
              {row[headerData[1].columnKey]}
            </div>
            <div
              className={headerData[2].itemClassName}
              data-testid={headerData[2].columnKey}
            >
              {row[headerData[2].columnKey]}
            </div>
          </div>
        );
      }}
    </FixedSizeList>
  );
}
